import React from 'react';

export default function ConductSection({ conduct, generalComment }) {
  if (!conduct || conduct.length === 0) return null;

  return (
    <>
      <p className="rc-section-title">Conduct &amp; Character</p>
      <table className="rc-conduct-table">
        <thead>
          <tr>
            <th style={{ width: '35%' }}>Category</th>
            <th style={{ width: '20%' }}>Rating</th>
            {/* <th style={{ width: '10%', textAlign: 'center' }}>Score</th> */}
            {/* <th>Remarks</th> */}
          </tr>
        </thead>
        <tbody>
          {conduct.map((entry, i) => (
            <tr key={entry.id || i}>
              <td>{entry.category?.category_name || '-'}</td>
              <td>
                <span className="rc-rating-pill">
                  {entry.rating?.rating_name || '-'}
                </span>
              </td>
              {/* <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                {entry.rating?.rating_value ?? '-'}
              </td> */}
              {/* <td style={{ fontSize: '8.5pt', fontStyle: 'italic', color: '#444' }}>
                {entry.remarks || '-'}
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
